import { encounterMeasurementRanges } from './enums.js';

/**
 * IMC = poids (kg) / taille (m)², arrondi au centième.
 *
 * Une seule fonction pour l'écran et pour l'enregistrement : ce qui s'affiche pendant la saisie
 * est ce que le serveur stocke. `null` quand la taille ou le poids sort de la plage partagée
 * (`encounterMeasurementRanges`) — l'écran dit alors « hors plage », jamais « requis ».
 */
export function computeBmi(heightCm: number, weightKg: number): number | null {
  if (!Number.isFinite(heightCm) || !Number.isFinite(weightKg)) return null;
  const height = encounterMeasurementRanges.height_cm;
  const weight = encounterMeasurementRanges.weight_kg;
  if (
    heightCm < height.min ||
    heightCm > height.max ||
    weightKg < weight.min ||
    weightKg > weight.max
  ) {
    return null;
  }
  const heightM = heightCm / 100;
  return Math.round((weightKg / (heightM * heightM)) * 100) / 100;
}
